import React, { Component } from 'react';
import './test-results.scss';
import { Constants, ImageConstants } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import TestResultDetails from '../test-result-details-V2/test-result-details'
import WronglyAnswered from '../../../common/wrong-answers-modal/wrong-answers-modalV1/wrong-answers-modal'
import TestApi from '../../../../apis/test'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ReactTooltip from 'react-tooltip';
import { faDownload, faEllipsisV, faFileDownload, faSpinner, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
// import ReactPDF, { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import AnswerSheet from '../answer-sheet-pdf-report/answer-sheet-pdf-report';
import ChapterEloAssessmentReport from '../../../class-work-V1/reports/evaluation-report/student-report/student-report';
import CommonApi from '../../../../apis/common';

class TestResultReport extends Component {
    state = {
        showTestResultDetailReport: false,
        levels: [
            {
                type: "NOVICE",
                title: "Novice",
                subTitle: '<50%',
                students: [
                ]
            },
            {
                type: "PROFICIENT",
                title: "Proficient",
                subTitle: '51% - 80%',
                students: []
            },
            {
                type: "ADVANCE",
                title: "Advance",
                subTitle: '>80%',
                students: []
            }
        ]
    }

    levelColors = {
        1: "#8B8BF6",
        2: "#FFBB7C",
        3: "#80D2F4"
    }

    selectedItem = {

    }

    constructor(props) {
        super(props)


        let chaptersList = []

        // chaptersList.push(this.props.match.params.chapter)


        // this.selectedItem = {
        //     chapters: chaptersList,
        //     class: this.props.match.params.class,
        //     createdDate: this.props.match.params.createdDate,
        //     _id: this.props.match.params.homeworkId,

        //     schoolName: this.props.match.params.schoolName,
        //     teacherName: this.props.match.params.teacherName,
        //     city: this.props.match.params.city,
        //     branch: this.props.match.params.branch,

        // }



    }




    componentDidMount() {

        this.getTestResultReport()
        console.log(this.props.selectedItem)
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }

    handleClickEvent = (event) => {
        if (this.studentRef && !this.studentRef.contains(event.target)) {
            this.setState({ showNotCompletedList: false })
        }
    }

    getTestResultReport(payload = {}) {

        this.setState({ isLoading: true })

        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit

        if (this.props.selectedItem) {
            payload.testId = this.props.selectedItem._id
        }

        TestApi.getTestResultReport(payload)
            .then(response => {

                console.log("response", response)

                let levels = this.state.levels
                let noviceStudents = response?.noviceStudents || []
                let proficientStudents = response?.proficientStudents || []
                let advancedStudents = response?.advancedStudents || []
                let notCompletedStudents = response?.notCompletedStudents || []

                levels[0].students = noviceStudents
                levels[1].students = proficientStudents
                levels[2].students = advancedStudents

                this.setState({ levels, notCompletedStudents, isLoading: false })

            }).catch(err => {
            })
    }

    onClickReportCardInfo = (type, students) => {

        let userIds = []

        for (let i = 0; i < students.length; i++) {
            userIds.push(students[i].userId)
        }

        this.setState({ showWrongAnswersReport: true, userIds, selectedStatus: type })
    }

    hideReport = () => {
        this.setState({ showWrongAnswersReport: false })
    }

    onClickNotCompleted = () => {
        this.setState({ showNotCompletedList: true })
    }

    closeStudents() {
        this.setState({ showNotCompletedList: false })
    }

    toggleMenuOptions = (lindex, index) => {
        this.setState({
            showMenuOptions: !this.state.showMenuOptions, selectedLevelIndex: lindex, selectedItemIndex: index
        })
    }

    renderStudents = () => {

        return (
            <div id="table-scoll" className="table-responsive mt-8" style={{ background: 'rgb(233 232 232)', borderRadius: "10px" }}>
                <table className="table cw-table mb-0 align-items-center custom-homework-table-2">
                    <thead>
                        <tr>
                            {this.state.levels && this.state.levels.length ? this.state.levels.map((item, index) => (
                                <th className='th-radius td-min-width' style={{ backgroundColor: this.levelColors[index + 1] }}>
                                    <div className=' homework-text text-center'>
                                        <span>{item.title} <small className='ml-2'> |   {item.subTitle}</small></span>
                                        {
                                            item.students?.length ?
                                                <img className='float-right info-icon cursor-pointer' src={getImageSource(ImageConstants.REPORT_CARD_INFO)} onClick={() => this.onClickReportCardInfo(item.type, item.students)} />
                                                : ""
                                        }
                                    </div>
                                </th>
                            )) : ""}
                        </tr>
                    </thead>
                    <tbody className="bg-white" >

                        <tr className="mt-4">
                            {
                                this.state.levels && this.state.levels.length ? this.state.levels.map((item, lindex) => (
                                    <td className='students-column number-of-students' onMouseEnter={ReactTooltip.rebuild}>
                                        <div className=''>
                                            {item.students && item.students.length ? item.students.map((student, index) => (
                                                <div className='row '>
                                                    <div className='col-12 p-5 each-record'>
                                                        <div className='row mb-4 ' >
                                                            <div className='col-2'>
                                                                {
                                                                    student.image ? <img className="student-image" alt="img" src={`${student.basePath}${student.image}`} />
                                                                        :
                                                                        <img className="student-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />
                                                                }
                                                            </div>
                                                            <div className='col-7 my-auto'>
                                                                <div className='student-name'>{student.name}</div>
                                                                <div className='student-roll-no'>Roll No : {student.rollNo}</div>
                                                            </div>
                                                            <div className='col-3 text-right menu-options-container'>


                                                                <div className='question-wrapper d-flex align-items-center '>
                                                                    <div className='d-flex align-items-center border-right-for-question pr-2'>
                                                                        <img data-tip={"Show Question Analysis Report"}
                                                                            className='question-mark-icon cursor-pointer'
                                                                            src={getImageSource(ImageConstants.QUESTION_MARK)}
                                                                            onClick={() => this.showTestResultDetailsReport(student, "Details")} />

                                                                    </div>
                                                                    <div className='d-flex align-items-center pl-2'>
                                                                        <img data-tip={"Download Student Performance Report"}
                                                                            className='download-report-icon cursor-pointer'
                                                                            src={getImageSource(ImageConstants.CASE_STUDY_DOWNLOAD_ICON)}
                                                                            onClick={() => this.onShowStudentReport(student, "Details")} />

                                                                    </div>
                                                                </div>

                                                                {/* <span className='cursor-pointer'>
                                                                    <FontAwesomeIcon icon={faEllipsisV} color='#000000' onClick={() => this.toggleMenuOptions(lindex, index)} />
                                                                </span> */}
                                                                {/* {this.state.showMenuOptions && (index == this.state.selectedItemIndex && lindex == this.state.selectedLevelIndex) && (
                                                                    <div className='menu-options'>
                                                                        <div className='text-right'>
                                                                            <img className='close-icn' onClick={this.toggleMenuOptions} src={getImageSource(ImageConstants.CROSS)} />
                                                                        </div>
                                                                        <div
                                                                            className='option cursor-pointer'
                                                                            onClick={() => this.showTestResultDetailsReport(student, "Details")}
                                                                        >
                                                                            Student Level Assessment Report
                                                                        </div>
                                                                        <div
                                                                            className='option cursor-pointer'
                                                                        >
                                                                            <span onClick={() => this.showTestResultDetailsReport(student, "AnswerSheet")}>View Answer Sheet</span>
                                                                            
                                                                        </div>
                                                                    </div>
                                                                )
                                                                } */}

                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className='col'>
                                                                <div className='marks-card'>
                                                                    <div>
                                                                        <div className='student-name text-center'>{student.marks} / {student.totalMark}</div>
                                                                        <div className='roll-no'>marks</div>
                                                                        <div className='student-name mt-1'>{this.calculatePercentage(student.marks, student.totalMark)}%</div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col'>
                                                                <div className='marks-card'>
                                                                    <div>
                                                                        <div className='student-name text-center'>{student.time}</div>
                                                                        <div className='roll-no'>Time (mins)</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='col'>
                                                                <div className='answered-card'>
                                                                    <div>
                                                                        <div className='row'>
                                                                            <div className='dot green-dot'></div>
                                                                            <span className='roll-no'>{student.correct} Correct</span>
                                                                        </div>
                                                                        <div className='row'>
                                                                            <div className='dot red-dot'></div>
                                                                            <div className='roll-no'>{student.inCorrect} In-Correct</div>
                                                                        </div>
                                                                        <div className='row'>
                                                                            <div className='dot yellow-dot'></div>
                                                                            <div className='roll-no'>{student.notAttempted} Not Attempted</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <PDFViewer >
                                                        <AnswerSheet student={student} selectedItem={this.props.selectedItem} />
                                                    </PDFViewer> */}
                                                    {
                                                        item.students?.length - 1 != index ?
                                                            <img className='' src={getImageSource(ImageConstants.SEPARATOR)} />
                                                            : ""
                                                    }
                                                </div>
                                            )) :
                                                <div className="no-data text-center">
                                                    <img className="" src={getImageSource(ImageConstants.NO_DATA)} />
                                                    <div className="empty">This is Empty</div>
                                                    <div className="no-student">No Student in this bucket</div>
                                                </div>
                                            }
                                        </div>
                                    </td>
                                )) : ""
                            }
                        </tr>

                    </tbody>
                </table >
            </div >
        )
    }

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }


    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    onShowStudentReport(user) {
        this.setState({ showStudentReport: true, selectedStudent: user, selectedHomework: this.props.selectedItem })
    }

    hideStudentReport() {
        this.setState({ showStudentReport: false })
    }


    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{this.getChapterNames(this.props.selectedItem?.chapters)} {`>`} </span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }




    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideTestResultsReport && this.props.delegate.hideTestResultsReport()
    }

    showTestResultDetailsReport = (item, type) => {
        if (type == 'Details') {
            this.setState({ showTestResultDetailReport: true, selectedAction: 'ResultDetails', selectedStudent: item })
        }
        else if (type == 'AnswerSheet') {
            this.setState({ showTestResultDetailReport: true, selectedAction: 'AnswerSheet', selectedStudent: item })
        }

    }

    hideTestResultDetailsReport = () => {
        this.setState({ showTestResultDetailReport: false })
    }

    renderStudentCard() {
        return (
            <div className='students-card' ref={ref => this.studentRef = ref}>

                <div className="row">
                    <div className="col">
                        <img className="close-icon cursor-pointer" onClick={(event) => this.closeStudents()} src={getImageSource(ImageConstants.CROSS)} />
                    </div>
                </div>

                {this.state.notCompletedStudents?.length ? this.state.notCompletedStudents?.map((item, index) =>
                    <div className='px-4 py-2 row align-items-center'>
                        <div className="profile-avatar text-center mr-2 d-inline-block">
                            <div className="row justify-content-center">
                                {item.image ? <img className="" alt="img" src={`${item.basePath}${item.image}`} />
                                    :
                                    <img className="" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />}
                            </div>
                        </div>
                        <div className='student-name ml-2'>
                            {item.name}
                        </div>
                    </div>

                )
                    :
                    <div className="text-center pt-4">No Records Found</div>
                }
            </div>
        )
    }

    downloadAllStudentsReportToPDF() {

        if (this.state.isDownloading) return

        let payload = {
            class: this.props.selectedItem.class,
            section: this.props.selectedItem.section,
            sectionId: this.props.selectedItem.sectionId,
            type: this.props.selectedItem.type,
        }

        if (this.props.selectedItem._id) {
            payload.homeworkId = this.props.selectedItem._id ? this.props.selectedItem._id : null
        }

        this.setState({ isDownloading: true })

        CommonApi.getAllStudentsReportPdf(payload).then((response) => {
            console.log(response)
            // Create a temporary URL for the Blob
            // Create a temporary URL for the Blob

            if (!(response instanceof Blob)) {
                //
                console.log('not a blob')
            }

            // Create a temporary URL for the Blob
            const url = window.URL.createObjectURL(response);

            // Create an anchor element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Student Performance Report ' + (new Date).toISOString() + '.zip'; // Name of the downloaded file
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            this.setState({ isDownloading: false })
            alert('Student Report Downloaded Successfully')

        }).catch(err => {
            this.setState({ isDownloading: false })
            console.log(err)
        })
    }



    render() {
        if (this.state.showWrongAnswersReport) {
            return <WronglyAnswered type="TEST"
                show={this.state.showWrongAnswersReport} delegate={this} close={this.hideWrongAnswersReport}
                usersId={this.state.userIds} selectedStatus={this.state.selectedStatus}
                selectedItem={this.props.selectedItem} />
        }
        if (this.state.showTestResultDetailReport) {
            return <TestResultDetails delegate={this}
                student={this.state.selectedStudent}
                selectedItem={this.props.selectedItem}
                selectedAction={this.state.selectedAction}
            />
        }

        if (this.state.showStudentReport) {
            return <ChapterEloAssessmentReport
                type={this.props.selectedItem.type}
                delegate={this} selectedItem={this.state.selectedHomework}
                student={this.state.selectedStudent}
            />
        }

        return (
            <div className='test-result-report-1'>

                {/* <div className='mb-5'>
                    <img alt="" className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div> */}
                {/* <div className='container-1'>
                    <div className='ml-4 mb-3 item1' >
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>
                    <div className='item-2'>
                        <span className='screen-title title-center my-5'>Assessment Results</span>
                    </div>
                </div> */}


                {/* <span>{this.renderBreadcrumb()}</span>
                 */}

                <div className='mb-3 item1 d-flex justify-content-between' >
                    <div>
                        <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                    </div>

                    <div className="d-flex ">
                        {/* <div className="export-button cursor-pointer mr-3" onClick={() => this.downloadPDF()}>Export Overall Report to PDF</div> */}
                        {/* <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadAllStudentsReportToPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Export All Students Report to PDF'}</div> */}
                        {
                             this.props.selectedItem.isStudentBulkReportGenerationDone ?
                                <div className="export-button cursor-pointer mr-4" onClick={() => this.downloadAllStudentsReportToPDF()}>{this.state.isDownloading ? 'Downloading...' : 'Export All Students Report to PDF'}</div>
                                :
                                <></>
                        }
                    </div>
                </div>
                <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.EVALUATION_DETAIL_REPORT)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1'>Evaluation Report</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>


                {
                    this.state.notCompletedStudents?.length ? <div className="text-right pt-4 mr-5 position-relative">
                        <span className="text-danger cursor-pointer" onClick={this.onClickNotCompleted}><FontAwesomeIcon icon={faTimesCircle} /> Not Completed <span className="not-completed text-primary">{this.state?.notCompletedStudents?.length} Students</span></span>
                        {this.state.showNotCompletedList ? this.renderStudentCard() : ""}
                    </div> : ""
                }

                <div className='pt-2'>
                    {this.renderStudents()}
                </div>
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />
            </div >);
    }
}

export default TestResultReport;